import { SerifHeading } from '../components/primitives';
import signIn from '../components/plan/signInLink.module.css';

/**
 * Build 32 item 4 (founder-ratified 2026-09-24) — the four developer route
 * codes are gone; the page is one heading and one way out, and it reads the
 * same signed in or out (it carries no auth of its own). The link goes to
 * `/`, not a client-side route, so the server's own redirect (every
 * non-`/v2`,`/api` route 307s to `/v2/landing`) decides where "home" is.
 */
export function NotFound() {
  return (
    <div style={{ padding: 40, maxWidth: 480, margin: '0 auto' }}>
      <SerifHeading level="md">We can&rsquo;t find that page.</SerifHeading>
      <p style={{ marginTop: 12 }}>
        <a className={signIn.signInLink} href="/">
          Go to the home page
        </a>
      </p>
    </div>
  );
}
